export const targetGroupsByVirtualConstants = {
  TARGET_GROUPS_BY_VIRTUAL_LOADING: "TARGET_GROUPS_BY_VIRTUAL_LOADING",
  TARGET_GROUPS_BY_VIRTUAL_SUCCESS: "TARGET_GROUPS_BY_VIRTUAL_SUCCESS",
  TARGET_GROUPS_BY_VIRTUAL_FAILURE: "TARGET_GROUPS_BY_VIRTUAL_FAILURE",
};

export const createTargetGroupsByVirtualConstants = {
  CREATE_TARGET_GROUPS_BY_VIRTUAL_LOADING:
    "CREATE_TARGET_GROUPS_BY_VIRTUAL_LOADING",
  CREATE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS:
    "CREATE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS",
  CREATE_TARGET_GROUPS_BY_VIRTUAL_FAILURE:
    "CREATE_TARGET_GROUPS_BY_VIRTUAL_FAILURE",
};

export const editTargetGroupsByVirtualConstants = {
  EDIT_TARGET_GROUPS_BY_VIRTUAL_LOADING:
    "EDIT_TARGET_GROUPS_BY_VIRTUAL_LOADING",
  EDIT_TARGET_GROUPS_BY_VIRTUAL_SUCCESS:
    "EDIT_TARGET_GROUPS_BY_VIRTUAL_SUCCESS",
  EDIT_TARGET_GROUPS_BY_VIRTUAL_FAILURE:
    "EDIT_TARGET_GROUPS_BY_VIRTUAL_FAILURE",
};

export const deleteTargetGroupsByVirtualConstants = {
  DELETE_TARGET_GROUPS_BY_VIRTUAL_LOADING:
    "DELETE_TARGET_GROUPS_BY_VIRTUAL_LOADING",
  DELETE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS:
    "DELETE_TARGET_GROUPS_BY_VIRTUAL_SUCCESS",
  DELETE_TARGET_GROUPS_BY_VIRTUAL_FAILURE:
    "DELETE_TARGET_GROUPS_BY_VIRTUAL_FAILURE",
};
